// extracted by mini-css-extract-plugin
export default {"connect":"WalletConnect_connect__tzMxN","address":"WalletConnect_address__xD9jZ"};